;
let DEV = 'http://localhost:8080';
let PROD = 'https://aq.zitju.com';

let SERVICE_URL = PROD; 
export default SERVICE_URL



// WEBPACK FOOTER //
// ./src/api/url.js